<section class="partner-hotels">
    <p-carousel [value]="partner"
                [numVisible]="3"
                [numScroll]="1"
                [responsiveOptions]="responsiveOptions"
                [autoplayInterval]="2000"
                class="partner-hotels__carousel partner__carousel">
        <ng-template let-partner pTemplate="item">
            <img [id]="'partner-'+ partner.id" [src]="partner.source" [alt]="partner.alt" [class]="'partner-hotels__carousel-item__image-'+partner.id">
        </ng-template>
    </p-carousel>
</section>
